// extracted by mini-css-extract-plugin
export default {"root":"F4xjlp"};